import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchAffiliateProfileThunk } from "./thunks";
import { AffProfileState } from "./types";

const initialState: AffProfileState = {
  affProfile: null,
  error: {},
  loading: false,
  loaded: false,
  upLoading: false,
  upLoaded: false,
  modalNewPayout: false,
  modalAssignPayout: false,
};

const affProfileSlice = createSlice({
  name: "affiliateProfile",
  initialState,
  reducers: {
    modalAssignPayout: (state, action: PayloadAction<boolean>) => {
      state.modalAssignPayout = action.payload;
    },
    modalNewPayout: (state, action: PayloadAction<boolean>) => {
      state.modalNewPayout = action.payload;
    },
    clearAffiliateProfile: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAffiliateProfileThunk.pending, state => {
        state.loading = true;
      })
      .addCase(fetchAffiliateProfileThunk.fulfilled, (state, action) => {
        state.affProfile = action.payload;
        state.loading = false;
        state.loaded = true;
      })
      .addCase(fetchAffiliateProfileThunk.rejected, (state, action) => {
        state.error = action.payload || {};
        state.loading = false;
        state.loaded = false;
      });
  },
});

export const { clearAffiliateProfile } = affProfileSlice.actions;

export default affProfileSlice.reducer;
